var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16857_2352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 12.5417L11.375 12.5417C11.8582 12.5417 12.25 12.15 12.25 11.6667L12.25 2.04175C12.25 1.5585 11.8582 1.16675 11.375 1.16675L2.625 1.16675C2.14175 1.16675 1.75 1.5585 1.75 2.04175L1.75 11.6667C1.75 12.15 2.14175 12.5417 2.625 12.5417Z",
    stroke: "#42296E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.91675H4.66667",
    stroke: "#42296E",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.66675H4.66667",
    stroke: "#42296E",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.41675H4.08333",
    stroke: "#42296E",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.75H10.5",
    stroke: "#42296E",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5H10.5",
    stroke: "#42296E",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 6.70825V4.08325H8.16675",
    stroke: "#42296E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 6.70825H5.83325",
    stroke: "#42296E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16675 6.70841V2.91675H9.62508",
    stroke: "#42296E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 6.41675V2.91675H9.33341",
    stroke: "#42296E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16857_2352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIconActive);
export default __webpack_public_path__ + "static/media/reportIcon-active.2052c8a45f6a4527bc7c4226f68db5d3.svg";
export { ForwardRef as ReactComponent };